import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Redirects logged-out users to /login (preserves intended destination via
 * `state.from`). While the token is still being verified we render a small
 * placeholder so the protected page doesn't flash for a single frame.
 */
export const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div
        data-testid="protected-route-loading"
        className="min-h-[60vh] flex items-center justify-center text-charcoal-400 text-sm"
      >
        Verifying session…
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
};

export default ProtectedRoute;
